<big-ui-link
    *transloco="let t; prefix: 'search'"
    class="block"
    [href]="item.url"
    [linkClass]="
        'block no-underline after:hidden rounded-lg p-4 hover:bg-white dark:hover:bg-primary-400 focus-visible:outline-primary-500 dark:focus-visible:outline-white' +
        (item.type === 'big_form' ? ' bg-primary-100 focus-visible:bg-primary-100 dark:bg-primary-500' : '')
    ">
    <div class="overflow-x-hidden">
        @if (item.type === 'big_form') {
            <div class="text-primary dark:text-white">{{ t('simplyFillOutOnline') }}</div>
        }

        <h2 class="h5 mt-0 mb-2 flex">
            {{ item.title }}

            @if (isPrivateUrl) {
                <span class="ml-2 w-5">
                    <big-icon
                        [icon]="myBigIcon"
                        [size]="'w-5'"
                        class="fill-current" />
                </span>
            }
        </h2>

        <p
            class="mb-0 font-sans"
            [innerHTML]="item.body | highlight: highlightString"></p>

        @if (item.breadcrumb.length) {
            <big-ui-breadcrumb
                class="mt-2 font-sans text-current"
                [entries]="item.breadcrumb" />
        }
    </div>
</big-ui-link>
